import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const PackagesHero = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="pt-32 pb-12 bg-white">
      <div className="max-w-[1440px] mx-auto px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-poppins font-bold text-4xl lg:text-5xl text-gray-900 mb-4">
            Sigorta Acentelerine Özel Dijital Paketler
          </h1>
          <p className="font-poppins text-base text-gray-600 max-w-2xl mx-auto">
            İhtiyacınıza uygun paketi seçin, dijital dönüşümünüzü başlatın
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PackagesHero;
